import { GameController } from "../game/controller";
import { installModalBehavior } from "./modal";
import { isNativeApp } from "../platform";

export function openSettingsModal(controller: GameController, overlayContainer: HTMLElement): void {
  const backdrop = document.createElement("div");
  backdrop.className = "modal-backdrop";
  const modal = document.createElement("div");
  modal.className = "modal settings-modal";
  const s = controller.state.settings;
  modal.innerHTML = `
    <h2>Settings</h2>
    <label>
      <span>Tutor mode</span>
      <select name="tutor">
        <option value="tutor">Tutor — every turn</option>
        <option value="trainer">Trainer — end of game</option>
        <option value="off">None</option>
      </select>
    </label>
    <label class="checkbox">
      <input type="checkbox" name="pip" ${s.showPipCount ? "checked" : ""}/>
      <span>Show pip count</span>
    </label>
    <label class="checkbox">
      <input type="checkbox" name="equity" ${s.showEquity ? "checked" : ""}/>
      <span>Show equity</span>
    </label>
    <label class="checkbox">
      <input type="checkbox" name="autoroll" ${s.autoRoll ? "checked" : ""}/>
      <span>Auto-roll</span>
    </label>
    <label class="checkbox">
      <input type="checkbox" name="sound" ${s.soundEnabled ? "checked" : ""}/>
      <span>Sound effects</span>
    </label>
    ${isNativeApp() ? "" : `
    <p class="settings-footnote">
      <a href="/download.html">Get the Android app</a> — plays offline, fullscreen, no browser bar.
    </p>`}
    <div class="actions">
      <button data-action="done" class="primary">Done</button>
    </div>
  `;
  backdrop.appendChild(modal);
  overlayContainer.appendChild(backdrop);

  const tutorSel = modal.querySelector<HTMLSelectElement>('select[name="tutor"]')!;
  tutorSel.value = s.tutorMode;
  const pipBox = modal.querySelector<HTMLInputElement>('input[name="pip"]')!;
  const equityBox = modal.querySelector<HTMLInputElement>('input[name="equity"]')!;
  const autoRollBox = modal.querySelector<HTMLInputElement>('input[name="autoroll"]')!;
  const soundBox = modal.querySelector<HTMLInputElement>('input[name="sound"]')!;

  // Apply each toggle immediately so the user sees the effect in real time.
  const applyOne = (patch: Partial<typeof s>): void => {
    controller.setSettings({ ...controller.state.settings, ...patch });
  };
  tutorSel.addEventListener("change", () => applyOne({ tutorMode: tutorSel.value as typeof s.tutorMode }));
  pipBox.addEventListener("change", () => applyOne({ showPipCount: pipBox.checked }));
  equityBox.addEventListener("change", () => applyOne({ showEquity: equityBox.checked }));
  autoRollBox.addEventListener("change", () => applyOne({ autoRoll: autoRollBox.checked }));
  soundBox.addEventListener("change", () => applyOne({ soundEnabled: soundBox.checked }));

  const close = (): void => backdrop.remove();
  modal.querySelector<HTMLButtonElement>('[data-action="done"]')!.addEventListener("click", close);
  installModalBehavior(backdrop, { onRequestClose: close, closeOnBackdrop: true });
}
